import React, { useEffect, useRef, useState, cloneElement, ReactElement, HTMLAttributes } from "react";

interface DeleteConfirmActionProps {
  triggerElement: ReactElement<HTMLAttributes<HTMLElement>>;
  confirmText: React.ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
  onCloseMenu?: () => void;
  top?: string;
  left?: string;
}

export const DeleteConfirmAction: React.FC<DeleteConfirmActionProps> = ({
  triggerElement,
  confirmText,
  onConfirm,
  onCancel,
  onCloseMenu,
  top,
  left = 0,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const confirmRef = useRef<HTMLDivElement | null>(null);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    onConfirm();
    setConfirmOpen(false);
    onCloseMenu?.();
  };

  const handleCancel = () => {
    onCancel?.();
    setConfirmOpen(false);
    onCloseMenu?.();
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (confirmRef.current && !confirmRef.current.contains(e.target as Node)) {
        setConfirmOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const triggerWithHandler = cloneElement(triggerElement, {
    onClick: (e: any) => {
      if (triggerElement.props.onClick) {
        triggerElement.props.onClick(e);
      }
      if (!e.defaultPrevented) {
        handleClick(e);
      }
    },
    style: {
      cursor: "pointer",
      ...triggerElement.props.style,
    },
  });

  return (
    <>
      {triggerWithHandler}

      {confirmOpen && (
        <div
          ref={confirmRef}
          style={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: top || "calc(100% - 60px)",
            left: left,
            width: 'max-content',
            minWidth: 270,
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: 8,
            boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            padding: "12px 16px",
            zIndex: 10000,
            // transform: "translateY(4px)",
            wordWrap: 'break-word',
          }}
        >
          <div style={{ marginBottom: 8 }}>{confirmText}</div>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-sm btn-outline-secondary me-2"
              onClick={handleCancel}
            >
              Отмена
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={handleConfirm}
            >
              Удалить
            </button>
          </div>
        </div>
      )}
    </>
  );
};